<template>
  <div class="poster-item">
    <img class="pic" v-lazy="value.cover">
    <div class="select-bg-view" />
    <img
      v-if="selectId && value.id == selectId"
      class="select-icon"
      src="../../assets/selected.png"
    >
    <img v-else class="select-icon" src="../../assets/unselect.png">
  </div>
</template>

<script>
export default {
  name: "PosterItem",
  props: {
    value: Object,
    selectId: String,
  },
};
</script>

<style lang="less" scoped >
image[lazy=loading] {
  width: 100%;
  height: 100%;
}
.poster-item {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  .pic {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 0;
  }
  .select-bg-view {
    width: 0.4rem;
    height: 0.4rem;
    position: absolute;
    right: 0.2rem;
    bottom: 0.2rem;
    border-radius: 50%;
    background: #ffffff;
    z-index: 9;
  }
  .select-icon {
    width: 0.6rem;
    height: 0.6rem;
    position: absolute;
    right: 0.1rem;
    bottom: 0.1rem;
    border-radius: 50%;
    z-index: 10;
  }
}
</style>